// extracted by mini-css-extract-plugin
export default {"modalFooter":"Modal_modalFooter__zezUX","modalHeader":"Modal_modalHeader__FkPKG","closeBtn":"Modal_closeBtn__rzL3m"};